module.exports = __webpack_public_path__ + "img/ic-blokk.e6c35b9f.svg";